<template>
	<nav class="bg-gray-700 p-6 py-3" :class="{'bg-purple-700':location== 'Forecast Order'}">
		<div class="container flex items-center justify-between flex-wrap mx-auto" key="containerKey">
			<div class="flex items-center flex-shrink-0 text-white mr-6">
				<router-link :to="role!='Driver' ? '/' : '/orders/pulled'" v-on:click.native="show = false" v-if="role!='Driver'">
					<img class="w-16 sm:w-24 h-auto mr-10" alt="MLE logo" src="@/assets/MLELogo.png">
				</router-link>
				<span class="font-thin sm:text-xl leading-none">
					<slot></slot>
				</span>
			</div>
			<div class="block lg:hidden" v-if="isLoggedIn && role != 'Driver'">
				<button class="flex items-center rounded text-blue-200 border-blue-400 hover:text-white hover:border-white focus:text-white focus:border-white focus:outline-none" @click="show=!show">
					<svg class="fill-current h-5 w-5" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
				</button>
			</div>
			<div class="sm:flex items-center space-x-4" :class="show ? '' : 'hidden'" v-if="isLoggedIn && role != 'Driver'">
				<div class="text-sm flex justify-end space-x-4">
					<router-link class="" to="/reports" v-if="role === 'Super Admin' || role === 'Administrator' || role === 'Accounts'" v-on:click.native="show = !show">
						<action-button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300">
							<file-text-icon class="w-5 h-5 mr-1"></file-text-icon>
							<span>Reports</span>
						</action-button>
					</router-link>
					<router-link class="" to="/orders" v-if="role === 'Super Admin' || role === 'Administrator' || role === 'Regional Manager' || role === 'Site Manager' || role === 'Store Man'" v-on:click.native="show = !show">
						<action-button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300">
							<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
							<span>Orders</span>
						</action-button>
					</router-link>
					<router-link class="" to="/orders/new" v-if="role === 'Head Office Storeman'" v-on:click.native="show = !show">
						<action-button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300">
							<clipboard-icon class="w-5 h-5 mr-1"></clipboard-icon>
							<span>Orders</span>
						</action-button>
					</router-link>
					<div class="relative" v-if="role === 'Super Admin' || role === 'Accounts'">
						<button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300" v-on:click="show = !show; toggle('forecasts')">
							<activity-icon class="w-5 h-5 mr-1"></activity-icon>
							<span>Forecasts</span>
						</button>
						<button class="fixed inset-0 w-full h-full cursor-default" v-if="menus.forecasts" @click="toggle('forecasts')"></button>
						<div class="absolute right-0 mt-2 bg-white rounded-lg shadow-lg z-20 w-48 overflow-hidden" v-if="menus['forecasts']">
							<router-link :to="`/forecasts/${regionid}/orders`" class="block py-2 px-4 hover:bg-gray-300 " v-for="(region, regionid) in regions" :key="`forecasts_${regionid}`"  @click.native="toggle('forecasts')">
								{{ region }}
							</router-link>
						</div>						
					</div>
					<div class="relative" v-if="role === 'Super Admin' || role === 'Accounts'">
						<button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300" v-on:click="show = !show; toggle('reticulation')">
							<zap-icon class="w-5 h-5 mr-1"></zap-icon>
							<span>Reticulation</span>
						</button>
						<button class="fixed inset-0 w-full h-full cursor-default" v-if="menus.reticulation" @click="toggle('reticulation')"></button>
						<div class="absolute right-0 mt-2 bg-white rounded-lg shadow-lg z-20 w-48 overflow-hidden" v-if="menus['reticulation']">
							<router-link :to="`/forecasts/${regionid}/reticulation`" class="block py-2 px-4 hover:bg-gray-300 " v-for="(region, regionid) in regions" :key="`reticulation_${regionid}`"  @click.native="toggle('reticulation')" v-if="role == 'Super Admin' || role == 'Accounts' || regionid == profiles[0].pivot.region_id">
								{{ region }}
							</router-link>
						</div>
					</div>
					<div v-if="role === 'Super Admin' || role === 'Accounts' || role === 'Head Office Storeman' || role === 'Regional Manager'">
						<action-button class="block mt-4 flex items-center mt-0 text-gray-200 hover:text-blue-300" v-on:click.native="show = !show; toggle('stock')">
							<box-icon class="w-5 h-5 mr-1"></box-icon>
							<span>Stock</span>
						</action-button>
						<button class="fixed inset-0 w-full h-full cursor-default" v-if="menus.stock" @click="toggle('stock')"></button>
						<div class="absolute right-0 mt-2 bg-white rounded-lg shadow-lg z-20 w-48 overflow-hidden" v-if="menus['stock']">
							<router-link :to="`/forecastorders`" class="block py-2 px-4 hover:bg-gray-300" @click.native="toggle('stock')" v-if="role !== 'Regional Manager'">
								Receiving
							</router-link>
							<router-link :to="`/stock/stock-allocation/${profiles[0].pivot.region_id}`" class="block py-2 px-4 hover:bg-gray-300" @click.native="toggle('stock')">
								Stock Allocation
							</router-link>
							<router-link :to="`/stock/${profiles[0].pivot.region_id}`" class="block py-2 px-4 hover:bg-gray-300" @click.native="toggle('stock')">
								Warehouse Levels
							</router-link>
							<!-- <router-link :to="`/stock/${regionid}`" class="block py-2 px-4 hover:bg-gray-300 " v-for="(region, regionid) in regions" :key="`stock_${regionid}`"  @click.native="toggle('stock')">
								Import {{ region }} stock
							</router-link> -->
						</div>
					</div>
				</div>
				<div class="relative">
					<action-button class="block mt-4 pr-4 flex items-center mt-0 text-white hover:text-blue-300 focus:outline-none" @button-clicked="showProfile=!showProfile">
						<user-icon class="w-5 h-5 mr-1"></user-icon>
						<span>{{ name }}</span>
						<chevron-component :show="!showProfile" mode="up"></chevron-component>
					</action-button>
					<button class="fixed inset-0 w-full h-full cursor-default" v-if="showProfile" @click="showProfile=false"></button>
					<div class="absolute right-0 mt-2 py-2 bg-white rounded-lg shadow-lg z-30" v-if="showProfile">
						<select v-model="role" name="profile" class="block bg-white border px-4 py-2 mx-4 rounded leading-tight focus:outline-none focus:shadow-outline" v-if="profiles.length > 1">
							<option v-for="profile in profiles" :value="profile.name" :key="profile.id">{{ profile.name }}</option>
						</select>
						<a title="Logout" class="flex items-center text-sm px-4 py-2 leading-none border rounded text-blue-300 border-white cursor-pointer hover:border-transparent hover:text-blue-500 hover:bg-white mt-4 mt-0" @click="logout">
							<log-out-icon class="w-5 h-5 mr-2"></log-out-icon> Logout
						</a>
					</div>
				</div>
			</div>			
		</div>
	</nav>
</template>

<script>
import { LogOutIcon } from 'vue-feather-icons'
import { UserIcon } from 'vue-feather-icons'
export default {
	name: 'NavBar',

	data () {
		return {
			show: true,
			containerKey: 0,
			showProfile: false,
			menus: {
				forecasts: false,
				reticulation: false,
			},
			regions: {
				1: 'Gauteng',
				2: 'KZN',
				3: 'Cape Town',
			}
		}
	},
	computed: {
		location: function(){
			return this.$route.name
		},
		isLoggedIn: function () {
			return this.$store.getters['auth/loggedIn']
		},
		role: {
			get: function(){
			return this.$store.getters['auth/role']
			},
			set: function(value) {
				console.log('setting');
				this.$store.commit('auth/setRole', value);
				let region_id = null;
				console.log(this.profiles);
				this.profiles.forEach(profile => {
					if(profile.name==value)
					{
						region_id = profile.pivot.region_id;
					}
				});
				console.log(region_id);
				this.$store.commit('auth/setRegionId', region_id);

				let default_url = '';
				if(this.$store.getters['auth/role']=='Driver')
				{
					// console.log(value);
					let region_id = this.$store.getters['auth/region_id'];
					default_url = `/orders/${region_id}/pulled`;
					// console.log(default_url);
					this.$router.push(`/orders/${region_id}/pulled`);
				}
				else 
				{
					// default_url = '/'
					if(this.$route.name=='Jobs')
					{
						this.containerKey+=1;
						this.$emit('reload');
						// location.reload();
					}
					else 
					{
						this.$router.push(`/`);
					}
				}
				
			}
		},
		name: function(){
			return this.$store.getters['auth/username']
		},
		profiles: function(){
			return this.$store.getters['auth/profiles']
		},
	},
	components: {
		LogOutIcon,
		UserIcon
	},
	methods: {
		toggle: function(what){
			Object.keys(this.menus).forEach(index => {
				if(index != what){
					this.menus[index] = false
				}
			});
			if(this.menus[what]){
				this.menus[what] = !this.menus[what];
				return;
			}else{
				this.$set(this.menus, what, true);
			}
		},
		getRole(event)
		{
			// console.log("Role change : "+event.target.value);
			this.$store.commit('auth/setRole', event.target.value);
		},
		logout: function () {
			this.$store.dispatch('auth/logout')
				.then(() => {
					//this.$router.push('/login');
					window.location.href = '/login'
				})
		},
	}
}
</script>

<style lang="css" scoped>
</style>
